const NA = 'N/A';
const DEFAULT_LOCALE = 'en-US';
const DEFAULT_CURRENCY = 'USD';
const MONTHS = ' Months';
const PERCENTAGE = '%';
const SNS_MAX_TRIES = 3;
const CURRENCY_SYMBOL ='$';
const DEFAULT_TIMEZONE = 'America/New_York';
const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
const DEFAULT_DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss A';
const DEFAULT_COLOR = { "background-color" : "#E5EDFB", "color" : "#0055D5", "border": "1px solid #99BBEE" }; //Blue
const FINANCIAL_DATA_FORMAT_VALUES = { '$': 1, 'M': 1000, 'MM': 1000000 };
const ACCESS_DENIED = '<em>Access Denied</em>';

const MICROSERVICE_API_URLS = {
    loans: `loan`,
    existingloans: `loan`,
    creditpackages: "loan",
    commitments: `loan`,
    relationship: `relationship`,
    collateral: `collateral`,
    covenant: `covenant`,
    tickler: `covenant`,
    exceptions: `exception`,
    files: `filemanager`,
    riskrating: `riskrating`,
    creditavailability: "creditavailability",
    spreads: "spreadingsl",
    flexiform: "flexiform",
    user: "admin",
    existingcommitments: `loan`
}
const FORM_TEMPLATE_POPULATE_FIELDS_URLS = {
    loans: `populateLoanFields`,
    existingloans: `populateLoanFields`,
    creditpackages: `populateLoanFields`,
    commitments : `populateLoanFields`,
    relationship: `populateRelationshipFields`,
    collateral: `populateCollateralFields`,
    covenant: `populateFields`,
    tickler: `populateFields`,
    exceptions: `populateExceptionFields`,
    files: `populateFileFields`,
    riskrating: `populateRiskModelFields`,
    creditavailability: "populateCAModelFields",
    spreads: "populateSpreadFields",
    user: "api/admin/populateUserFields",
    existingcommitments: `populateLoanFields`
}

const POPULATE_FIELDS_CONFIG = {
    BATCH_SIZE : 5,
   MAX_CONCURRENT : 6
};

const MAX_QUERY_TIME_MS = 30000; // 30 seconds

export {
    NA,
    DEFAULT_LOCALE,
    DEFAULT_CURRENCY,
    MONTHS,
    PERCENTAGE,
    SNS_MAX_TRIES,
    CURRENCY_SYMBOL,
    DEFAULT_TIMEZONE,
    DEFAULT_DATE_FORMAT,
    DEFAULT_COLOR,
    FINANCIAL_DATA_FORMAT_VALUES,
    ACCESS_DENIED,
    MICROSERVICE_API_URLS,
    FORM_TEMPLATE_POPULATE_FIELDS_URLS,
    DEFAULT_DATE_TIME_FORMAT,
    POPULATE_FIELDS_CONFIG,
    MAX_QUERY_TIME_MS
}